export default __webpack_public_path__ + "static/media/04 - Data Visualization.354cae1e.png";